<template>
    <LogsList/>
</template>

<script>
import LogsList from '../../components/logs/LogsList';

export default {
  components: {
    LogsList,
  },
};
</script>
